import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import HomeComponent from './components/home.vue';
import VerificationComponent from './components/verification.vue';
import ConfirmationComponent from './components/confirmation.vue';
import LandingApprovalComponent from './components/landingApproval.vue';
import LandingDeclinedComponent from './components/landingDenied.vue';
import LandingTechnicalIssueComponent from './components/technialProblem.vue';
import EmailUpdateHomeComponent from './components/emailUpdateHome.vue';
import EmailUpdateComponent from './components/emailUpdate.vue';
import EmailUpdateApproved from './components/emailUpdateApproval.vue';
import EmailUpdateIssue from './components/emailUpdateIssue.vue';
import RedirectPageComponent from './components/RedirectPage.vue';
import EbiennialFixSearchComponent from './components/ebiennialFixSearch.vue';
import EbiennialFixComponent from './components/ebiennialFix.vue';
import ReprocessEbiennialFromPaymentComponent from './components/reprocessEbiennialFromPayment.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/redirect',
      name: 'redirect',
      component: RedirectPageComponent,
    },
    {
      path: '/reprocessEbiennialFromPSS',
      name: 'reprocessEbiennialFromPSS',
      component: ReprocessEbiennialFromPaymentComponent,
    },

    {
      path: '/fix',
      name: 'fix',
      component: EbiennialFixComponent,
    },
    {
      path: '/fixSearch',
      name: 'fixSearch',
      component: EbiennialFixSearchComponent,
    },

    {
    path: '/',
    name: 'home',
    component: HomeComponent,
  },
    {
      path: '/home',
      name: 'home',
      component: HomeComponent,
    },
    {
      path: '/emailUpdateHome',
      name: 'emailUpdateHome',
      component: EmailUpdateHomeComponent,
    },
    {
      path: '/emailUpdate',
      name: 'emailUpdate',
      component: EmailUpdateComponent,
    },

    {
      path: '/verification',
      name: 'verification',
      component: VerificationComponent,
    },
    //{
    //  path: '/confirmation/:ssl_*',
    //  name: 'confirmation',
    //  component: ConfirmationComponent,
    //},
    {
      path: '/confirmation',
      name: 'confirmation',
      component: ConfirmationComponent,
    },
    {
      path: '/approved/',
      name: 'approved',
      component: LandingApprovalComponent,
    },
    {
      path: '/denied/',
      name: 'denied',
      component: LandingDeclinedComponent,
    },
    {
      path: '/issue/',
      name: 'issue',
      component: LandingTechnicalIssueComponent,
    },
    {
      path: '/emailUpdateIssue/',
      name: 'emailUpdateIssue',
      component: EmailUpdateIssue,
    },
    {
      path: '/emailUpdateApproved/',
      name: 'emailUpdateApproved',
      component: EmailUpdateApproved,
    },

    {

      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
  ],
});
